import React from "react";
import "../../css/buttons/Tags.css";

import { IoAdd } from "react-icons/io5";
import { useDispatch } from "react-redux";

import { openCounseling } from "../../features/counseling";

const Tags = ({ name, link }) => {

    const dispatch = useDispatch()
    const openInNewTab = (url) => {
        window.open(url, '_blank').focus();
    }

    return (
        <button
            className={ "Tags"}
            onClick={() => {
                (link)?openInNewTab(link):dispatch(openCounseling())
            }}
        >
            <span className="tag-name">{name}</span>
            <span className={"tags-circle"}>
                <IoAdd />
            </span>
        </button>
    );
};

export default Tags;
